export const STATUS = {
  DRAFT: 1,
  IN_REVIEW: 2,
  UPDATE_REQUIRED: 3,
  APPROVED: 4,
  REJECTED: 5,
  ERROR: 6,
};

export const AMENDMENT_TYPE = {
  DEFAULT: 0,
  DELETION: 1,
  RENEWAL: 2,
  EMPLOYER_CHANGE: 3,
};

export const EMPLOYER_CHANGE_TYPE = {
  CHANGE_OF_EMPLOYER: 1,
  ADDITIONAL_EMPLOYER: 2,
};
